import React, { useState } from "react";

import Dot from "./Dot";
import Line from "./Line";
import { ArrowLeft, ArrowRight } from "phosphor-react";
import Slide from "./Slide";

import mockupLike from "~/images/mockup_like.png";
import mockupSkip from "~/images/mockup_skip.png";
import mockupFilters from "~/images/mockup_filters.png";
import mockupMessage from "~/images/mockup_message.png";
import mockupProfil from "~/images/mockup_profil.png";

export default function Slider() {
  const [indexSlider, setIndexSlider] = useState(0);

  const changeSliderIndex = (index) => {
    setIndexSlider(index);
  };

  const previousIndex = () => {
    if (indexSlider === 0) {
      setIndexSlider(4);
    } else {
      setIndexSlider(indexSlider - 1);
    }
  };

  const nextIndex = () => {
    if (indexSlider === 4) {
      setIndexSlider(0);
    } else {
      setIndexSlider(indexSlider + 1);
    }
  };

  const slides = [
    <Slide
      nbSlide={1}
      image={mockupLike}
      title="Swipez à droite"
      description="Glissez vers la droite si le profil vous intéresse"
    />,
    <Slide
      nbSlide={2}
      image={mockupSkip}
      title="Swipez à gauche"
      description="Glissez vers la gauche si le profil ne vous intérresse pas"
    />,
    <Slide
      nbSlide={3}
      image={mockupFilters}
      title="Filtrez"
      description="Bénéficiez d'un grand nombre de filtres pour trouver des profils qui vous correspondent le mieux"
    />,
    <Slide
      nbSlide={4}
      image={mockupMessage}
      title="Entrez en contact"
      description="Communiquez avec les profils avec lesquels vous avez été mis en relation"
    />,
    <Slide
      nbSlide={5}
      image={mockupProfil}
      title="Personnalisez votre profil"
      description="Modifiez facilement vos informations"
    />,
  ];

  return (
    <div className="flex flex-col justify-center items-center md:px-20 px-4 py-10 gap-y-6">
      <div className="w-[90%] max-w-[1400px] flex justify-center items-center">
        {slides.map((slide, index) => {
          let classNames = "";
          if (index === indexSlider) {
            classNames = "transition delay-200 duration-200 opacity-100";
          } else {
            classNames = "opacity-0 max-w-0 transition duration-150";
          }
          return (
            <div className={`${classNames}`} key={index}>
              {slide}
            </div>
          );
        })}
      </div>
      <div className="flex md:space-x-10 space-x-2 justify-center">
        <ArrowLeft
          font="bold"
          size={30}
          onClick={previousIndex}
          className="text-gray-500 hover:cursor-pointer hover:text-primary transition-all duration-300 ease-in-out lg:mr-10"
        />
        <div className="flex justify-center items-center h-[28px]">
          <Dot
            selected={indexSlider === 0}
            onClick={changeSliderIndex}
            index={0}
          />
          <Line />
          <Dot
            selected={indexSlider === 1}
            onClick={changeSliderIndex}
            index={1}
          />
          <Line />
          <Dot
            selected={indexSlider === 2}
            onClick={changeSliderIndex}
            index={2}
          />
          <Line />
          <Dot
            selected={indexSlider === 3}
            onClick={changeSliderIndex}
            index={3}
          />
          <Line />
          <Dot
            selected={indexSlider === 4}
            onClick={changeSliderIndex}
            index={4}
          />
        </div>
        <ArrowRight
          font="bold"
          size={30}
          onClick={nextIndex}
          className="text-gray-500 hover:cursor-pointer hover:text-primary transition-all duration-300 ease-in-out lg:!ml-20"
        />
      </div>
    </div>
  );
}
